import { BdLocale } from './locale';

export function LocaleResolver($window) {
    const svc = BdLocale;
    return svc($window);
}
LocaleResolver.$inject = ['$window'];
